import React from 'react';
import { ReactComponent as DeleteIcon } from '../../assets/images/icons/deleteIcon.svg';

export default function Delete(props) {
  return (
    <DeleteIcon width={props.size} height={props.size} className={`icon ${props.className}`} />
  );
}
